import { render, staticRenderFns } from "./ManageTeams.vue?vue&type=template&id=2468b928"
import script from "./ManageTeams.vue?vue&type=script&lang=js"
export * from "./ManageTeams.vue?vue&type=script&lang=js"
import style0 from "./ManageTeams.vue?vue&type=style&index=0&id=2468b928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports